import React, { FC, PropsWithChildren } from 'react'
import ReactDOM from 'react-dom/client'
import App from './app'
import reportWebVitals from './reportWebVitals'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { store } from './store/store'
import { ConfigProvider, App as AntdApp } from 'antd'
import ruRu from 'antd/locale/ru_RU'
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import duration from 'dayjs/plugin/duration'
import { ErrorBoundary, initGlitchTip } from './monitoring/glitchtip'

dayjs.locale('ru')
dayjs.extend(duration)

initGlitchTip()

export const StoreProvider: FC<PropsWithChildren> = ({ children }) => {
    return <Provider store={store}>{children}</Provider>
}

export const AppConfigProvider: FC<PropsWithChildren> = ({ children }) => {
    return (
        <ConfigProvider
            theme={{
                token: {
                    fontSizeHeading1: 28,
                    fontSizeHeading2: 24,
                    fontSizeHeading3: 21,
                    fontSizeHeading4: 18,
                },
                components: {
                    Layout: {
                        headerHeight: 50,
                        headerPadding: '0 24px',
                    },
                    InputNumber: {
                        // controlWidth: '100%'
                    },
                    DatePicker: {
                        // presetsWidth: '100%',
                    },
                },
            }}
            locale={ruRu}
        >
            <AntdApp>{children}</AntdApp>
        </ConfigProvider>
    )
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
    <React.StrictMode>
        <ErrorBoundary
            fallback={<p>Произошла ошибка. Мы уже получили отчёт — попробуйте обновить страницу.</p>}
        >
            <BrowserRouter>
                <StoreProvider>
                    {/* <ConfigProvider theme={{ algorithm: theme.darkAlgorithm }}> */}
                    <AppConfigProvider>
                        <App />
                    </AppConfigProvider>
                </StoreProvider>
            </BrowserRouter>
        </ErrorBoundary>
    </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
